<template>
<FilterMe @onClear="clearCheckbox" @onSubmit="filters => filterMe(filters)" :filters="filters">
    <template #form="{filters}">
        <CRow>
            <CCustomInputCheckbox
                v-if="$policy('media').view_any_or_group"
                col="12"
                class="mb-3"
                :name="filters.is_starred === true ? 'ستاره‌دار' : (filters.is_starred === false ? 'بدون ستاره' : 'ستاره‌دار یا بدون ستاره')"
                v-model="filters.is_starred"
                ref="customCheckbox"
            />
            <CCol col="12" v-if="$policy('media').view_any_or_group">
                <CInput v-model="filters.user.full_name" :placeholder="$t('publisher.name')" />
            </CCol>
            <CCol col="12" v-if="$policy('media').view_any_or_group">
                <CInput v-model="filters.user.phone" :placeholder="$t('publisher.phone')" />
            </CCol>
            <CCol col="12">
                <CInput v-model="filters.name" :placeholder="$t('media.name')" />
            </CCol>
            <CCol col="12" v-if="$policy('media').view_any_or_group">
                <CSelect2 v-model="filters.level" :options="mediaLevelOptionWithNull" ignoreOptionStyle />
            </CCol>
            <CCol col="12" v-if="$policy('media').view_any_or_group">
                <CInput v-model="filters.url" :placeholder="$t('media.url')" />
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.type" :options="mediaTypeOptionWithNull" ignoreOptionStyle />
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.status" :options="mediaStatusOptionWithNull" ignoreOptionStyle />
            </CCol>

            <CCol col="12">
                <div role="group" class="form-group datepicker">
                    <datePicker
                        :placeholder="$t('attributes.created_from')"
                        :clearable="true" format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control"
                        v-model="filters.min_created_at" type="datetime"
                    />
                </div>
            </CCol>
        </CRow>
    </template>
</FilterMe>
</template>

<script>
import CCustomInputCheckbox from './../components/CCustomInputCheckbox'
import { mapActions } from 'vuex'
import { MediaType } from '@/constants'
import { mediaTypeOptionWithNull, mediaStatusOptionWithNull, mediaLevelOptionWithNull } from '@/common/data'

export default {
    name: 'FilterIt',

    components: {
        CCustomInputCheckbox,
    },

    data() {
        return {
            MediaType,
            mediaTypeOptionWithNull,
            mediaStatusOptionWithNull,
            mediaLevelOptionWithNull,
            filters: {
                name: '',
                type: '',
                status: '',
                min_created_at: '',
                min_updated_at: '',
                user: {
                    full_name: '',
                    phone: '',
                },
                is_starred: null,
                level: '',
                url: '',
            },
        }
    },

    methods: {
        ...mapActions({
            fetch: 'media/fetch',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        filterMe(filters) {
            this.setShowLoading(true)
            this.fetch({
                page: 1,
                ...filters,
            }).then(() => this.setShowLoading(false))
        },
        clearCheckbox(item) {
            this.$refs.customCheckbox.checked = null
        }
    },
}
</script>